import type { ClientType, FieldType, IClientIndex } from '@/interfaces'

export class ClientIndex implements IClientIndex {
	[key: string]: FieldType
	id: number | string
	name?: string
	type: ClientType
	active: boolean
	federalTaxID?: string
	salesPerson: string
	primaryContact: string
	pinnacleCloudURL: string
	clientIntakeForm: boolean

	constructor({
		id,
		name,
		type,
		active,
		federalTaxID,
		salesPerson,
		primaryContact,
		pinnacleCloudURL,
		clientIntakeForm
	}: IClientIndex) {
		this.id = id
		this.name = name
		this.type = type
		this.active = active
		this.federalTaxID = federalTaxID
		this.salesPerson = salesPerson
		this.primaryContact = primaryContact
		this.pinnacleCloudURL = pinnacleCloudURL
		this.clientIntakeForm = clientIntakeForm
	}

	get activeStatus(): string {
		if (this.type === 'Lead') {
			if (this.active) {
				if (this.clientIntakeForm) {
					return 'Ready'
				}
				return 'Lead'
			}
			return 'Inactive'
		} else if (this.type === 'Client') {
			if (this.active) {
				return 'Active'
			}
			return 'Inactive'
		}
		return ''
	}
}
